import { jsx as _jsx } from "react/jsx-runtime";
import { Analytics } from "@biocentury/core";
import { Product } from "@biocentury/core/types";
import React from "react";
var TrialLink = function(param) {
    var title = param.title, href = param.href, classNames = param.classNames;
    return /*#__PURE__*/ _jsx("a", {
        onClick: function() {
            Analytics.WebUsage.track({
                action: "Click",
                category: href,
                product: Product.Profiles
            });
        },
        className: classNames,
        href: href,
        children: title
    });
};
export default TrialLink;
